const WRITE_FIELDS = [
  'phase',
  'kind',
  'name',
  'description',
  'language_scope',
  'language_id',
  'document_type',
  'priority',
  'trigger',
  'conditions',
  'actions',
  'valid_from',
  'valid_to',
];

export const toRuleWriteDto = (rule) => Object.fromEntries(
  WRITE_FIELDS
    .filter((key) => Object.prototype.hasOwnProperty.call(rule || {}, key))
    .map((key) => [key, rule[key]])
    .map(([key, value]) => {
      if (key === 'trigger' && value) {
        return [key, {
          display_value: value.display_value,
        }];
      }
      return [key, value];
    }),
);

export const createEmptyRuleDraft = (type, languageId = null) => {
  if (type === 'query') {
    return {
      phase: 'query',
      kind: 'query_override',
      name: '',
      description: null,
      language_scope: 'language',
      language_id: languageId == null ? null : String(languageId),
      document_type: 'product',
      priority: 100,
      trigger: { type: 'query.exact', display_value: '' },
      conditions: { match: 'all', items: [] },
      actions: [],
      valid_from: null,
      valid_to: null,
    };
  }
  return {
    phase: 'index',
    kind: 'product_ranking',
    name: '',
    description: null,
    language_scope: 'neutral',
    language_id: null,
    document_type: 'product',
    priority: 100,
    trigger: null,
    conditions: {
      match: 'all',
      items: [{ field: 'product_id', operator: 'eq', value: '' }],
    },
    actions: [{ type: 'score.multiply', value: 1.1 }],
    valid_from: null,
    valid_to: null,
  };
};
